import { InnerHTML } from '@headless-workspace/domain/common/client';
import { HTMLString } from '@headless-workspace/domain/common/server';
import { GlowModal } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';

type ProductDetailDeliveryInfoProps = {
    deliveryInfo: HTMLString;
};

export const ProductDetailDeliveryInfo: Component<ProductDetailDeliveryInfoProps> = ({ deliveryInfo }) => {
    return (
        <GlowModal.Content>
            <InnerHTML rawHtml={deliveryInfo} />
        </GlowModal.Content>
    );
};
